const redirectUri = () => `${window.location.origin}/`;

export const environment = {
  production: false,
  env: 'sit',
  baseUrl: 'http://localhost:4200',
  appName: '/',
  // apiUrl: 'https://consumerplus-sit.aksnau2sbsn002961701.chubbdigital.com/csmrp',
  apiUrl: 'https://cpstudio-sit.chubb.com/csmrp',
  mwApiUrl: 'https://cpstudio-sit.chubb.com/cpstudio-mw/api',

  msalConfig: {
    auth: {
      clientId: '37f18eec-c8a7-47de-a3af-86fc39d54c75',
      authority: 'https://login.microsoftonline.com/fffcdc91-d561-4287-aebc-78d2466eec29/',
    },
  },
  apiConfig: {
    scopes: ['User.read', 'GroupMember.read.All', 'openid', 'profile', 'offline_access'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  redirectUri: redirectUri(),
  // handlerGroup: ['CSRP-DEVL-SIT'],
  // managerGroup: ['CSRP-DEVL-SIT'],
  userGroup: ['CSRP-STUDIO-USERS-SIT'],
  superUserGroup: ['CSRP-STUDIO-SUSERS-SIT'],
  azureOpenAI: {
    apiKey: '',
    apiVersion: '2024-12-01-preview',
    textDeployment: 'gpt-4.1',
    imageDeployment: 'gpt-image-1.5',
  },
};
